export default {"src":"/_next/static/media/google.f2c1839d.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};